// extracted by css-extract-rspack-plugin
export default {"linksWrapper":"footer-fragment__LinksBlock_linksWrapper__dn3bw","linkGroup":"footer-fragment__LinksBlock_linkGroup__gAaVt"};